/* Ported from ac-cat-v2 assets/pdp-carousel.js. */
/* Atlas PDP: horizontal scrollers with progress bar + prev/next (Features cards, Related products).
   data-mode="feat": progress thumb = scrollLeft/max*(1-w); step = one card.
   data-mode="rel":  progress thumb = scrollLeft/scrollWidth; step = two cards. */
(function () {
  function init(box) {
    if (box.__pdpScroller) return;
    box.__pdpScroller = true;
    const mode = box.dataset.mode;
    const track = box.querySelector('[data-track]');
    const scope = box.closest('[data-scroll-scope]') || box.parentElement;
    const prog = scope.querySelector('[data-prog]');
    const prev = scope.querySelector('[data-scroll-prev]');
    const next = scope.querySelector('[data-scroll-next]');
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function update() {
      const max = track.scrollWidth - track.clientWidth;
      const w = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
      const l = mode === 'rel' ? (max > 0 ? track.scrollLeft / track.scrollWidth : 0) : (max > 0 ? (track.scrollLeft / max) * (1 - w) : 0);
      if (prog) { prog.style.width = (w * 100) + '%'; prog.style.left = (l * 100) + '%'; }
      const atStart = track.scrollLeft <= 2, atEnd = track.scrollLeft >= max - 2;
      if (prev) prev.style.opacity = atStart ? '0.35' : '1';
      if (next) next.style.opacity = atEnd ? '0.35' : '1';
    }
    function by(d) {
      const c = track.firstElementChild;
      const step = (c ? c.getBoundingClientRect().width + 10 : 300) * (mode === 'rel' ? 2 : 1);
      track.scrollBy({ left: d * step, behavior: reduce ? 'auto' : 'smooth' });
    }
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if (prev) prev.addEventListener('click', () => by(-1));
    if (next) next.addEventListener('click', () => by(1));
    setTimeout(update, 0);
  }
  function boot() { document.querySelectorAll('[data-scroller]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
